import React, { useEffect, useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";

const EMPTY = { title: "", description: "", assigned_to: "", due_date: "" };
const inputCls =
  "w-full h-10 px-3 hard border-2 border-[color:var(--border)] bg-white focus:border-[color:var(--primary)] outline-none text-sm";

export const TaskForm = ({ onCreated }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/users").then(({ data }) => setUsers(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/tasks", { ...form, due_date: form.due_date || null });
      toast.success("Görev atandı");
      setForm(EMPTY);
      onCreated();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="task-form" className="hard border border-[color:var(--border)] bg-[color:var(--surface)] p-5 space-y-4 h-fit">
      <div className="flex items-center gap-2">
        <Plus size={18} className="text-[color:var(--accent)]" />
        <h3 className="font-bold">Yeni Görev Ata</h3>
      </div>
      <div>
        <label className="ticker block mb-1 text-[color:var(--text-2)]">Başlık</label>
        <input data-testid="task-title-input" required value={form.title} onChange={set("title")} className={inputCls} />
      </div>
      <div>
        <label className="ticker block mb-1 text-[color:var(--text-2)]">Açıklama</label>
        <textarea
          data-testid="task-description-input"
          rows={3}
          value={form.description}
          onChange={set("description")}
          className="w-full px-3 py-2 hard border-2 border-[color:var(--border)] bg-white focus:border-[color:var(--primary)] outline-none text-sm"
        />
      </div>
      <div>
        <label className="ticker block mb-1 text-[color:var(--text-2)]">Atanan Kişi</label>
        <select data-testid="task-assignee-select" required value={form.assigned_to} onChange={set("assigned_to")} className={inputCls}>
          <option value="">Seçiniz…</option>
          {users.map((u) => (
            <option key={u.id} value={u.id}>{u.name || u.email}</option>
          ))}
        </select>
      </div>
      <div>
        <label className="ticker block mb-1 text-[color:var(--text-2)]">Son Tarih</label>
        <input data-testid="task-due-input" type="date" value={form.due_date} onChange={set("due_date")} className={inputCls} />
      </div>
      <button
        type="submit"
        disabled={saving}
        data-testid="task-submit"
        className="w-full h-11 hard bg-[color:var(--primary)] hover:bg-[color:var(--primary-hover)] text-white font-bold uppercase tracking-wider disabled:opacity-50 transition-opacity"
      >
        {saving ? "Kaydediliyor…" : "Görevi Ata"}
      </button>
    </form>
  );
};
